import { MarkDownEditor as MarkDownEditorComponent } from './MarkDownEditor.component';
import { connector } from './MarkDownEditor.connector';

export const CodeMirrorMarkDownEditor = connector(MarkDownEditorComponent);
